angular.module('gym.calendar').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.appointmentTypes', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.appointmentTypes.list', {
    url: '/appointment_types',
    template: require('templates/gyms/calendar/appointments/types/list.html.slim')
  }).state('gym.appointmentTypes.new', {
    url: '/appointment_types/new',
    template: require('templates/gyms/calendar/appointments/types/edit.html.slim')
  }).state('gym.appointmentTypes.edit', {
    url: '/appointment_types/:appointmentTypeId/edit',
    template: require('templates/gyms/calendar/appointments/types/edit.html.slim')
  });
}]);
